import { getTicketId, formatDate } from '@/utils/page-utils';
import pdfMake from 'pdfmake/build/pdfmake.min';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

let images = {};

const PRESUPUESTO = '1) Si el equipo contiene claves, contraseñas o patrón de desbloqueo que impidan la prueba correcta del mismo. Cliente puede aportarlas. En el caso de tener datos que consideren privados la empresa no tiene responsabilidad sobre los mismos, el cliente puede optar no aportar las calves retirarlo y traerlo nuevamente sin las mismas o que se realize la reparación sin la prueba correcta estando informado que no se pudo probar.  \n' +
'2) El Producto deberá ser retirado con presentación de la orden de servicio emitida por SMART DRONE SERVICE al momento de ingreso del mismo al taller.\n' +
'3) Para los articulos/productos que requieran costo también deberá ser presentada la factura emitida por SMART DRONE SERVICE, en conjunto con lo dicho en el Numeral 2.\n' +
'4) El cliente se compromete a declarar todos los fallos del Producto. La reparacion sera efectuada sobre lo declarado por el cliente, si en el proceso se detecta (No sera probadas todas las funciones buscando alguna otra falla)  alguna falla mas sera informado.\n' +
'5) SMART DRONE SERVICE no se hace responsable de fallos no declarados.\n' +
'6) SMART DRONE SERVICE no se hace responsable de los datos que pueda tener almacenados el cliente en el Producto, es responsabilidad del cliente tener respaldo de los mismos. Si los procesos de reparación requieren eliminar los datos se realizara sin previo aviso.\n' +
'7) Las reparaciones tienen 30 días de garantía, sobre la reparación y comienza desde la fecha de Factura.\n' +
'8) La garantía quedará invalidada en los siguientes casos :\n' +
'- Cualquier manipulación externa sea de Software o Hardware, siendo realizada por el Usuario o por otro Servicio Técnico.\n' +
'- Cualquier uso no debido del Producto tal como: caída, golpe fuerte, mal uso, contacto con humedad, liquido corrosivo o manipulación.\n' +
'9) SMART DRONE SERVICE no se hace responsable por accesorios dejados como "chips", "memorias" o "vidrios templado" etc.\n' +
'10) SMART DRONE SERVICE queda exenta de toda responsabilidad de cualquier otro tipo de fallo que no tenga relación directa con la reparación realizada.\n' +
'11) El cliente dispone de 60 días posterior al aviso via e-mail o whatsapp para retirar el producto sin costo adicional, una vez cumplido este plazo se cobrara un costo adicional de U$S 2 costo por día por concepto de almacenamiento.\n' +
'12) Es responsabilidad total del cliente revisar el producto en el momento que lo retira, luego de retirado el producto no se admitirán reclamos por estado o accesorios.\n' +
'13)Sera responsabilidad del cliente la comunicación para saber el estado de su presupuesto o reparación. El sistema le notificara automáticamente por e-mail los diferentes estados.\n' +
'14)El Fabricante, Importador o Comerciante: no asume ninguna responsabilidad por el extravío, olvido o desconocimiento de la/s cuenta/s y clave/s asociada/s al dispositivo. El usuario es responsable de su/s cuenta/s y clave/s,  ejemplo: Google, ICloud, BlackBerry ID, MI, entre otros.\n' +
'El ingreso de un Producto a Servicio Técnico a SMARTDRONE SERVICE implica el conocimiento y aceptación de estas condiciones.';

const GARANTIA = '1) El equipo ingresa como garantía condicionada, la misma no es comprobada hasta que el equipo es revisado y se constate el cumpliemiento o no, con las normas de garantía.\n' +
'2) SIEMPRE es necesario la presentación de la factura original para la acreditación de la garantía.\n' +
'3) El Producto deberá ser retirado con presentación de la orden de servicio emitida por SMART DRONE SERVICE al momento de ingreso del mismo, al taller.\n' +
'4) Para los Productos que requieran costo también deberá ser presentada la factura emitida por SMART DRONE SERVICE en conjunto con lo dicho en el punto 2.\n' +
'5) El cliente se compromete a declarar todos los fallos del articulo/producto.\n' +
'6) SMART DRONE SERVICE no se hace responsable de fallos no declarados.\n' +
'7) SMART DRONE SERVICE no se hace responsable de los datos que pueda tener almacenados el cliente en el Producto, es responsabilidad del cliente tener respaldo de los mismos. Si los procesos de reparación requieren eliminar los datos se realizara sin previo aviso.\n' +
'8) SMART DRONE SERVICE no se hace responsable por accesorios dejados como "chips", "memorias" o "vidrios templados".\n' +
'9) Si el equipo contiene claves, contraseñas o patrón de desbloqueo que impidan la prueba correcta del mismo. No sera revisado hasta aportar las mismas o serán borradas si el equipo lo permite. En el caso de tener datos que consideren privados la empresa no tiene responsabilidad sobre los mismos, el cliente puede optar no aportar las calves retirarlo y traerlo nuevamente sin las mismas.  \n' +
'10) Será responsabilidad del cliente la comunicación para saber el estado de su reparación.\n' +
'11) SMART DRONE SERVICE queda exenta de toda responsabilidad de cualquier otro tipo de fallo que no tenga relación directa con la reparación realizada.\n' +
'12) El cliente dispone de 60 días posterior al aviso via e-mail para retirar el producto sin costo adicional, una vez cumplido este plazo se cobrara un costo adicional de U$S 2 por día de uso del almacén.\n' +
'13) Es responsabilidad total del cliente revisar el producto en el momento que lo retira, luego de retirado el producto no se admitirán reclamos por estado o accesorios.\n' +
'14) Para hacer efectiva la garantía del dispositivo debe de tener desvinculadas todas la/s cuenta/s existentes en el mismo.\n' +
'El Fabricante, Importador o Comerciante: no asume ninguna responsabilidad por el extravío, olvido o desconocimiento de la/s cuenta/s y clave/s asociada/s al dispositivo. El usuario es responsable de su/s cuenta/s y clave/s, ejemplo: Google, ICloud, BlackBerry ID, MI, entre otros.\n' +
'El ingreso de un Producto a Servicio Técnico proporcionado por SMART DRONE SERVICE implica el conocimiento y aceptación de estas condiciones.';

const promise1 = new Promise((resolve) => {
    getDataUri('/resources/33447.png', (dataUri) => {
        images.wapImg = dataUri;
        resolve();
    });
});
const promise2 = new Promise((resolve) => {
    getDataUri('/resources/logo.png', (dataUri) => {
        images.topImg = dataUri;
        resolve();
    });
});
const promise3 = new Promise((resolve) => {
    // getDataUri('/resources/qrcode.png', (dataUri) => {
    //     images.qrImg = dataUri;
    resolve();
    // });
});
const promise4 = new Promise((resolve) => {
    getDataUri('/resources/condiciones.png', (dataUri) => {
        images.conditionsImg = dataUri;
        resolve();
    });
});

function getDataUri(url, callback) {
    var img = document.createElement('img');
    let canvas;

    img.src = url;
    img.onload = () => {
        canvas = document.createElement('CANVAS');
        canvas.width = img.width;
        canvas.height = img.height;

        canvas.getContext('2d').drawImage(img, 0, 0);
        // callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''))
        callback(canvas.toDataURL('image/png'));
        canvas = null;
    };
};

export function closingCase(data) {
    Promise.all([promise1, promise2, promise3, promise4]).then(() => {
        var today = new Date();
        // var todayStr = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();

        var docDefinition = {
            content: [
                {
                    color: '#0A0A0A',
                    margin: [0, 0, 0, 0],
                    table: {
                        widths: ['18%', '7%', '7%', '12%', '14%', '7%', '7%', '10%', '9%', '8%'],
                        heights: 12,
                        body: [
                            [{image: images.topImg, width: 260, height: 60, colSpan: 5, rowSpan: 4, border: [true, true, false, false]}, {}, {}, {}, {}, {image: images.wapImg, width: 190, colSpan: 5, rowSpan: 4, alignment: 'right', border: [false, true, true, false]}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Lunes a Viernes de 9 a 18 horas', style: 'leftTitle', colSpan: 4, border: [true, true, false, false]}, {}, {}, {}, {text: 'BAJA DE EQUIPOS EN SERVICIO TÉCNICO', style: 'rightTitle', colSpan: 6, alignment: 'right', border: [false, true, true, false]}, {}, {}, {}, {}, {}],
                            [{text: 'Ticket:', style: 'tableHeader', colSpan: 1}, {text: getTicketId(data), colSpan: 9}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Nombre:', style: 'tableHeader', colSpan: 1}, {text: data.customer.firstName, colSpan: 7}, {}, {}, {}, {}, {}, {}, {text: 'PIN:', style: 'tableHeader'}, {}],
                            [{text: 'Teléfono:', style: 'tableHeader', colSpan: 1}, {text: data.customer.phone, colSpan: 2}, {}, {text: 'Mail:', style: 'tableHeader'}, {text: data.customer.email.substring(0, 26) + (data.customer.email.length > 25 ? '..' : ''), colSpan: 4}, {}, {}, {}, {text: 'CLAVE:', style: 'tableHeader'}, {}],
                            [{text: 'No. Factura:', style: 'tableHeader', colSpan: 1}, {text: data.documentReferredId, colSpan: 2}, {}, {text: 'Fecha de Compra:', style: 'tableHeader', colSpan:2}, {}, {text: data.documentReferredDate, colSpan: 3}, {}, {}, {text: '\n\n\nPIN:', rowSpan: 3, colSpan: 2, style: 'tableHeader'}, {}],
                            // [{text: 'Fecha Compra:', style: 'tableHeader', colSpan: 1}, {text: data.documentReferredDate, colSpan: 7}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Modelo/Marca:', style: 'tableHeader', colSpan: 1}, {text: data.deviceBrand, colSpan: 7}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'SERIE/IMEI:', style: 'tableHeader', colSpan: 1}, {text: data.serialNo, colSpan: 7}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Información:', style: 'tableHeader', colSpan: 1, rowSpan: 4}, {text: data.issueDiagnostic, colSpan: 9, rowSpan: 4}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Accesorios:', style: 'tableHeader'}, {text: 'Caja:', colSpan: 2, style: 'subheader'}, {}, {text: 'Cargador:', style: 'subheader'}, {text: 'DataCable:', style: 'subheader'}, {text: 'Llave SIM:', style: 'subheader', colSpan: 2}, {}, {text: 'Auric:', style: 'subheader'}, {text: 'Otros:', style: 'subheader', colSpan: 2}, {}],
                            [{text: 'Observaciones:', style: 'tableHeader', colSpan: 1}, {text: data.accesorios, colSpan: 9}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'CONDICIONES DE EQUIPOS INGRESADOS PARA EVALUAR/TRAMITAR GARANTÍA', style: 'tableHeader', alignment: 'center', colSpan: 10}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{image: images.conditionsImg, width: 500, style: 'tableHeader', colSpan: 10, rowSpan: 3}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'HORARIO DE ATENCIÓN DE LUNES A VIERNES DE 9 A 18 HORAS', style: 'tableHeaderRed', alignment: 'center', colSpan: 10}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'En conformidad con lo anteriormente expresado:', style: 'tableHeader', alignment: 'center', colSpan: 10}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'FIRMA:', style: 'tableHeader', alignment: 'left', colSpan: 3, rowSpan: 1}, {}, {}, {text: 'ACLARACIÓN:', style: 'tableHeader', alignment: 'left', colSpan: 4, rowSpan: 1}, {}, {}, {}, {text: 'C.I.:', style: 'tableHeader', alignment: 'left', colSpan: 3, rowSpan: 1}, {}, {}],
                            // [{text: 'Costo:', style: 'tableHeader', alignment: 'left', colSpan: 3, rowSpan: 1}, {}, {}, {text: data.pricing ? '$ ' + data.pricing : 'sin costo.', style: 'tableHeader', alignment: 'left', colSpan: 4, rowSpan: 1}, {}, {}, {}, {text: '', style: 'tableHeader', alignment: 'left', colSpan: 3, rowSpan: 1}, {}, {}],
                        ]
                    }
                },
                // {
                //     image: images.qrImg,
                //     margin: [0, 0, 0, 0],
                //     width: 130
                // }
            ],
            styles: {
                subheader: {
                    fontSize: 10,
                    bold: true
                },
                tableHeader: {
                    bold: true,
                    fontSize: 11,
                    color: 'black'
                },
                leftTitle: {
                    fontSize: 11,
                    color: 'blue'
                },
                rightTitle: {
                    fontSize: 11,
                    color: 'red'
                },
                tableHeaderRed: {
                    fontSize: 10,
                    color: 'red'
                }
            }
        };

        pdfMake.createPdf(docDefinition).download('Baja_' + getTicketId(data) + '.pdf');
    });
};

export function openingCase(data) {
    var conditions;
    if (data.issueType === 'Presupuesto') {
        conditions = PRESUPUESTO;
    } else {
        conditions = GARANTIA;
    }

    Promise.all([promise1, promise2]).then(() => {
        var today = new Date();
        // var todayStr = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
        var styleIssueType = 'greenIssue';
        var docDefinition;

        if (data.issueType) {
            if (data.issueType.toLowerCase() === 'daferol') {
                data.issueType = 'DAFEROL';
            } else if (data.issueType.toLowerCase() === 'p' || data.issueType.toLowerCase() === 'presupuesto') {
                styleIssueType = 'redIssue';
            } else if (data.issueType.toLowerCase() === 'sancor') {
                styleIssueType = 'blueIssue';
            }
        } else {
            data.issueType = 'Smartdrone';
        }

        docDefinition = {
            content: [
                {
                    color: '#0A0A0A',
                    margin: [0, 0, 0, 0],
                    table: {
                        widths: ['18%', '7%', '7%', '12%', '14%', '7%', '7%', '10%', '9%', '8%'],
                        heights: 12,
                        body: [
                            [{text: data.issueType && data.issueType.toUpperCase(), style: styleIssueType, alignment: 'right', colSpan: 10}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{image: images.topImg, width: 260, height: 60, colSpan: 5, rowSpan: 4, border: [true, true, false, false]}, {}, {}, {}, {}, {image: images.wapImg, width: 190, colSpan: 5, rowSpan: 4, alignment: 'right', border: [false, true, true, false]}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Lunes a Viernes de 9 a 18 horas', style: 'leftTitle', colSpan: 4, border: [true, true, false, false]}, {}, {}, {}, {text: 'ORDEN DE INGRESO A SERVICIO TÉCNICO', style: 'rightTitle', colSpan: 6, alignment: 'right', border: [false, true, true, false]}, {}, {}, {}, {}, {}],
                            [{text: 'Ticket:', style: 'tableHeader', colSpan: 1}, {text: getTicketId(data) + ' (' + formatDate(data.dateCreated) + ')', colSpan: 9}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Nombre:', style: 'tableHeader', colSpan: 1}, {text: data.customer.firstName, colSpan: 7}, {}, {}, {}, {}, {}, {}, {text: 'PIN:', style: 'tableHeader'}, {}],
                            [{text: 'Teléfono:', style: 'tableHeader', colSpan: 1}, {text: data.customer.phone, colSpan: 2}, {}, {text: 'Mail:', style: 'tableHeader'}, {text: data.customer.email.substring(0, 26) + (data.customer.email.length > 25 ? '..' : ''), colSpan: 4}, {}, {}, {}, {text: 'CLAVE:', style: 'tableHeader'}, {}],
                            [{text: 'No. Factura:', style: 'tableHeader', colSpan: 1}, {text: data.documentReferredId, colSpan: 2}, {}, {text: 'Fecha:', style: 'tableHeader', colSpan: 1}, {text: data.documentReferredDate, colSpan: 1}, {text: 'SKU', style: 'tableHeader', colSpan: 1}, {text: data.sku, colSpan: 2}, {}, {text: '\n\n\nPIN:', rowSpan: 3, colSpan: 2, style: 'tableHeader'}, {}],
                            // [{text: 'Fecha Compra:', style: 'tableHeader', colSpan: 1}, {text: data.documentReferredDate, colSpan: 7}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Modelo/Marca:', style: 'tableHeader', colSpan: 1}, {text: data.deviceBrand, colSpan: 7}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'SERIE/IMEI:', style: 'tableHeader', colSpan: 1}, {text: data.serialNo, colSpan: 7}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Falla Acusada:', style: 'tableHeader', colSpan: 1, rowSpan: 4}, {text: data.issueDescription, colSpan: 9, rowSpan: 4}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Accesorios:', style: 'tableHeader'}, {text: 'Caja:', colSpan: 2, style: 'subheader'}, {}, {text: 'Cargador:', style: 'subheader'}, {text: 'DataCable:', style: 'subheader'}, {text: 'Llave SIM:', style: 'subheader', colSpan: 2}, {}, {text: 'Auric:', style: 'subheader'}, {text: 'Otros:', style: 'subheader', colSpan: 2}, {}],
                            [{text: 'Observaciones:', style: 'tableHeader', colSpan: 1}, {text: data.accesorios, colSpan: 9}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'CONDICIONES DE EQUIPOS INGRESADOS PARA EVALUAR/TRAMITAR GARANTÍA', style: 'tableHeader', alignment: 'center', colSpan: 10}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            // [{image: images.conditionsImg, width: 500, style: 'tableHeader', colSpan: 10, rowSpan: 3}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: conditions, style: 'extraSmall', colSpan: 10, rowSpan: 2}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            // [{text: 'Semana de carnaval cerrado por licencia anual.', style: 'tableHeaderRed', alignment: 'center', colSpan: 10 }, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'Todas las reparaciones se realizan en un tiempo aproximado de 7 días hábiles', style: 'tableHeader', alignment: 'center', colSpan: 10}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'SERÁ REQUISITO EXCLUYENTE LA PRESENTACION DE ÉSTA ORDEN DE INGRESO PARA CUALQUIER TRAMITE ANTE SMARTDRONE', style: 'tableHeaderRed', alignment: 'center', colSpan: 10}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                            [{text: 'FIRMA:', style: 'tableHeader', alignment: 'left', colSpan: 3, rowSpan: 1}, {}, {}, {text: 'ACLARACIÓN:', style: 'tableHeader', alignment: 'left', colSpan: 4, rowSpan: 1}, {}, {}, {}, {text: 'C.I.:', style: 'tableHeader', alignment: 'left', colSpan: 3, rowSpan: 1}, {}, {}]
                        ]
                    }
                },
                // {
                //     image: images.qrImg,
                //     margin: [0, 0, 0, 0],
                //     width: 130
                // }
            ],
            styles: {
                subheader: {
                    fontSize: 10,
                    bold: true
                },
                tableHeader: {
                    bold: true,
                    fontSize: 11,
                    color: 'black'
                },
                leftTitle: {
                    fontSize: 11,
                    color: 'blue'
                },
                rightTitle: {
                    fontSize: 11,
                    color: 'red'
                },
                extraSmall: {
                    fontSize: 8.5
                },
                tableHeaderRed: {
                    fontSize: 10,
                    color: 'red'
                },
                // Styles for issue type.
                blueIssue: {
                    fontSize: 14,
                    color: 'blue'
                },
                redIssue: {
                    fontSize: 14,
                    color: 'red'
                },
                greenIssue: {
                    fontSize: 14,
                    color: 'green'
                }
            }
        };

        pdfMake.createPdf(docDefinition).download('Alta_' + getTicketId(data) + '.pdf');
    });
};
